import { Link } from 'react-router-dom'
import { useLogout } from '../../../../../hooks/useLogout'

export const SessionCanva = () => {

    const logout = useLogout()

    return (
        // <div className="modal-body ModalBodyStyleSesion">

        //     <hr className="hr-session-top" data-bs-dismiss="modal" aria-label="Close" />

        //     <div className="user-icon-session">
        //         <div className="circle-icon-container">
        //             <span className="material-symbols-outlined mI-session notranslate">account_circle</span>
        //         </div>

        //         <div className="user-data-session">
        //             <p className="session-name">Admin </p>
        //             <p className="session-email">soportedigitaltpa@tpaoficial.com</p>
        //         </div>

        //     </div>

        //     <hr className="hr-session" />

        //     <a className="a-session " href="" onClick={logout}>
        //         <span className="material-symbols-outlined">exit_to_app</span>
        //         <p>Cerrar Sesión</p>
        //     </a>


        // </div>

        <div className='m-4'>
            <div className="user-icon-session">
                <div className="circle-icon-container">
                    <span className="material-symbols-outlined mI-session notranslate" aria-hidden="true" role="none">account_circle</span>
                </div>

                <div className="user-data-session">
                    <p className="session-name">Admin </p>
                    <p className="session-email">soportedigitaltpa@tpaoficial.com</p>
                </div>

            </div>

            <hr className="hr-session" />

            <Link className="a-session " to="" onClick={logout}>
                <span className="material-symbols-outlined" aria-hidden="true" role="none">exit_to_app</span>
                <p>Cerrar Sesión</p>
            </Link>

        </div>
    )
}
